function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import './index.less';

var Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);

  var _super = _createSuper(Player);

  function Player(props) {
    var _this;

    _classCallCheck(this, Player);

    _this = _super.call(this, props);
    _this.instance = null;

    _this.init = function (props) {
      if (window['Aliplayer']) {
        _this.setState({
          isLoading: false
        });

        _this.initAliplayer(props);
      } else {
        _this.insertScriptTag();
      }
    };
    /**
     * 获取阿里播放器的js路径
     */


    _this.getPath = function (path, version) {
      return path.replace(/\{([^{]*?)%version(.*?)\}/g, version.toString());
    };

    _this.insertLinkTag = function () {
      var _this$props = _this.props,
          _this$props$cssLinkTe = _this$props.cssLinkTemplate,
          cssLinkTemplate = _this$props$cssLinkTe === void 0 ? '' : _this$props$cssLinkTe,
          _this$props$version = _this$props.version,
          version = _this$props$version === void 0 ? '' : _this$props$version;
      var playerLinkTag = document.getElementById(_this.playerLinkId);

      if (!playerLinkTag) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = _this.getPath(cssLinkTemplate, version);
        ;
        link.id = _this.playerLinkId;
        document.head.appendChild(link);
      }
    };

    _this.insertScriptTag = function () {
      var _this$props2 = _this.props,
          _this$props2$scriptSr = _this$props2.scriptSrcTemplate,
          scriptSrcTemplate = _this$props2$scriptSr === void 0 ? '' : _this$props2$scriptSr,
          _this$props2$version = _this$props2.version,
          version = _this$props2$version === void 0 ? '' : _this$props2$version;
      var document = window.document;
      var playerScriptTag = document.getElementById(_this.playerScriptId);

      if (!playerScriptTag) {
        playerScriptTag = document.createElement('script');
        playerScriptTag.type = 'text/javascript';
        playerScriptTag.charset = 'utf-8';
        playerScriptTag.src = _this.getPath(scriptSrcTemplate, version);
        playerScriptTag.id = _this.playerScriptId;
        document.body.appendChild(playerScriptTag);
      }

      playerScriptTag.addEventListener('load', function () {
        _this.setState({
          isLoading: false
        });

        _this.initAliplayer(_this.props);
      });
    };

    _this.initEvents = function () {
      var _this$props3 = _this.props,
          onReady = _this$props3.onReady,
          onPlay = _this$props3.onPlay,
          onPause = _this$props3.onPause,
          onCanplay = _this$props3.onCanplay,
          onPlaying = _this$props3.onPlaying,
          onEnded = _this$props3.onEnded,
          onError = _this$props3.onError,
          onHideBar = _this$props3.onHideBar,
          onShowBar = _this$props3.onShowBar,
          onWaiting = _this$props3.onWaiting,
          onM3u8Retry = _this$props3.onM3u8Retry,
          onSnapshoted = _this$props3.onSnapshoted,
          onTimeupdate = _this$props3.onTimeupdate,
          onLiveStreamStop = _this$props3.onLiveStreamStop,
          onCancelFullScreen = _this$props3.onCancelFullScreen,
          onRequestFullScreen = _this$props3.onRequestFullScreen;
      if (!_this.instance) return;
      onReady && _this.instance.on('ready', onReady);
      onPlay && _this.instance.on('play', onPlay);
      onPause && _this.instance.on('pause', onPause);
      onCanplay && _this.instance.on('canplay', onCanplay);
      onPlaying && _this.instance.on('playing', onPlaying);
      onEnded && _this.instance.on('ended', onEnded);
      onHideBar && _this.instance.on('hideBar', onHideBar);
      onShowBar && _this.instance.on('showBar', onShowBar);
      onWaiting && _this.instance.on('waiting', onWaiting);
      onSnapshoted && _this.instance.on('snapshoted', onSnapshoted);
      onTimeupdate && _this.instance.on('timeupdate', onTimeupdate);
      onM3u8Retry && _this.instance.on('onM3u8Retry', onM3u8Retry);
      onLiveStreamStop && _this.instance.on('liveStreamStop', onLiveStreamStop);
      onCancelFullScreen && _this.instance.on('cancelFullScreen', onCancelFullScreen);
      onRequestFullScreen && _this.instance.on('requestFullScreen', onRequestFullScreen);
      onError && _this.instance.on('error', onError);
    };

    _this.initAliplayer = function (props) {
      var _this$instance;

      var source = props.source,
          options = props.options,
          isLive = props.isLive;

      var config = _objectSpread(_objectSpread({}, options), {}, {
        useH5Prism: true,
        id: _this.playerId,
        source: source,
        isLive: !!isLive
      });

      if (!config.width) {
        config.width = '100%';
      }

      if (!config.height) {
        config.height = '100%';
      }

      if (config.autoplay === undefined) {
        config.autoplay = false;
      } // 销毁播放器


      _this.instance && _this.instance.dispose(); // @ts-ignore

      var Aliplayer = window['Aliplayer'] || window.proxy.Aliplayer;
      _this.instance = new Aliplayer(config);
      (_this$instance = _this.instance) === null || _this$instance === void 0 ? void 0 : _this$instance.setVolume(0);

      _this.initEvents();
    };
    /**
     * 重新加载播放器
     */


    _this.reloadPlayer = function () {
      _this.initAliplayer(_this.props);
    };

    _this.playerId = "aliplayer-".concat(Math.floor(Math.random() * 1000000));
    _this.playerScriptId = 'ali-player-js';
    _this.playerLinkId = 'ali-player-css';
    _this.state = {
      isLoading: true
    };

    _this.insertLinkTag();

    return _this;
  }

  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init(this.props);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.source !== nextProps.source) {
        if (this.props.changeSourceMode === 'init') {
          this.init(nextProps);
        } else {
          nextProps.source && this.loadByUrl(nextProps.source);
        }

        return false;
      }

      if (this.props.options !== nextProps.options || this.props.isLive !== nextProps.isLive) {
        this.init(this.props);
        return false;
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.instance && this.instance.dispose();
    }
    /**
     * 获取播放器
     */

  }, {
    key: "getPlayer",
    value: function getPlayer() {
      return this.instance;
    }
    /**
     * 播放视频
     */

  }, {
    key: "play",
    value: function play() {
      var _this$instance2, _this$instance2$play;

      (_this$instance2 = this.instance) === null || _this$instance2 === void 0 ? void 0 : (_this$instance2$play = _this$instance2.play) === null || _this$instance2$play === void 0 ? void 0 : _this$instance2$play.call(_this$instance2);
    }
    /**
     * 暂停视频
     */

  }, {
    key: "pause",
    value: function pause() {
      var _this$instance3, _this$instance3$pause;

      (_this$instance3 = this.instance) === null || _this$instance3 === void 0 ? void 0 : (_this$instance3$pause = _this$instance3.pause) === null || _this$instance3$pause === void 0 ? void 0 : _this$instance3$pause.call(_this$instance3);
    }
    /**
     * 重播视频
     */

  }, {
    key: "replay",
    value: function replay() {
      var _this$instance4, _this$instance4$repla;

      (_this$instance4 = this.instance) === null || _this$instance4 === void 0 ? void 0 : (_this$instance4$repla = _this$instance4.replay) === null || _this$instance4$repla === void 0 ? void 0 : _this$instance4$repla.call(_this$instance4);
    }
    /**
     * 跳转到某个时刻进行播放，time的单位为秒。
     * @param time
     * @return player
     */

  }, {
    key: "seek",
    value: function seek(time) {
      var _this$instance5, _this$instance5$seek;

      (_this$instance5 = this.instance) === null || _this$instance5 === void 0 ? void 0 : (_this$instance5$seek = _this$instance5.seek) === null || _this$instance5$seek === void 0 ? void 0 : _this$instance5$seek.call(_this$instance5, time);
    }
    /**
     * 获取当前时间 单位秒
     * @param time
     */

  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      var _this$instance6, _this$instance6$getCu;

      return (_this$instance6 = this.instance) === null || _this$instance6 === void 0 ? void 0 : (_this$instance6$getCu = _this$instance6.getCurrentTime) === null || _this$instance6$getCu === void 0 ? void 0 : _this$instance6$getCu.call(_this$instance6);
    }
    /**
     * 获取视频总时长，返回的单位为秒
     */

  }, {
    key: "getDuration",
    value: function getDuration() {
      var _this$instance7, _this$instance7$getDu;

      return (_this$instance7 = this.instance) === null || _this$instance7 === void 0 ? void 0 : (_this$instance7$getDu = _this$instance7.getDuration) === null || _this$instance7$getDu === void 0 ? void 0 : _this$instance7$getDu.call(_this$instance7);
    }
    /**
     * 获取当前的音量，返回值范围为0-1
     */

  }, {
    key: "getVolume",
    value: function getVolume() {
      var _this$instance8, _this$instance8$getVo;

      return (_this$instance8 = this.instance) === null || _this$instance8 === void 0 ? void 0 : (_this$instance8$getVo = _this$instance8.getVolume) === null || _this$instance8$getVo === void 0 ? void 0 : _this$instance8$getVo.call(_this$instance8);
    }
    /**
     * 设置音量
     */

  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      this.instance.setVolume(volume);
    }
    /**
     * 切换播放视频url，time为可选值（单位秒）目前只支持同种格式（mp4/flv/m3u8）之间切换暂不支持直播rtmp流切换
     * @param url 视频地址
     * @param time 跳转到多少秒
     */

  }, {
    key: "loadByUrl",
    value: function loadByUrl(url, time) {
      var _this$instance9, _this$instance9$loadB;

      (_this$instance9 = this.instance) === null || _this$instance9 === void 0 ? void 0 : (_this$instance9$loadB = _this$instance9.loadByUrl) === null || _this$instance9$loadB === void 0 ? void 0 : _this$instance9$loadB.call(_this$instance9, url, time);
    }
    /**
     * 获取播放器状态
     */

  }, {
    key: "getStatus",
    value: function getStatus() {
      var _this$instance10, _this$instance10$getS;

      return (_this$instance10 = this.instance) === null || _this$instance10 === void 0 ? void 0 : (_this$instance10$getS = _this$instance10.getStatus) === null || _this$instance10$getS === void 0 ? void 0 : _this$instance10$getS.call(_this$instance10);
    }
    /**
     * 设置播放速度
     * @param speed
     */

  }, {
    key: "setSpeed",
    value: function setSpeed(speed) {
      var _this$instance11, _this$instance11$setS;

      (_this$instance11 = this.instance) === null || _this$instance11 === void 0 ? void 0 : (_this$instance11$setS = _this$instance11.setSpeed) === null || _this$instance11$setS === void 0 ? void 0 : _this$instance11$setS.call(_this$instance11, speed);
    }
    /**
     * 设置封面
     * @param cover
     */

  }, {
    key: "setCover",
    value: function setCover(cover) {
      var _this$instance12, _this$instance12$setC;

      (_this$instance12 = this.instance) === null || _this$instance12 === void 0 ? void 0 : (_this$instance12$setC = _this$instance12.setCover) === null || _this$instance12$setC === void 0 ? void 0 : _this$instance12$setC.call(_this$instance12, cover);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          className = _this$props4.className,
          style = _this$props4.style,
          hideControlbar = _this$props4.hideControlbar,
          loading = _this$props4.loading;
      var cls = [prefixCls, className, 'prism-player', hideControlbar ? 'hide-controlbar' : null].filter(function (item) {
        return item;
      }).join(' ').trim();
      return /*#__PURE__*/React.createElement("div", {
        className: cls,
        style: style,
        id: this.playerId
      }, this.state.isLoading ? loading || null : null);
    }
  }]);

  return Player;
}(React.Component);

Player.defaultProps = {
  prefixCls: 'pansy-aliplayer',
  hideControlbar: false,
  cssLinkTemplate: '//g.alicdn.com/de/prismplayer/{%version}/skins/default/aliplayer-min.css',
  scriptSrcTemplate: '//g.alicdn.com/de/prismplayer/{%version}/aliplayer-min.js',
  version: '2.9.7',
  options: {},
  changeSourceMode: 'init'
};
export * from './types';
export default Player;